import { ReactNode } from 'react';
import { usePermissions } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { PERMISSIONS } from '../../constants';

/** Telas internas: o backend exige isAdmin E attendant-goal-internal (o `+` do escopo Hapi é AND). */
const InternalGate = ({ children }: { children: ReactNode }) => {
  const { permissions, isLoading } = usePermissions();
  if (isLoading) { return null; }
  const perms: string[] = permissions ?? [];
  if (!perms.includes(PERMISSIONS.ADMIN) || !perms.includes(PERMISSIONS.ATTENDANT_GOAL_INTERNAL)) {
    return (
      <Box sx={{ p: 6, textAlign: 'center' }}>
        <Typography color="text.secondary">Acesso não autorizado.</Typography>
      </Box>
    );
  }
  return <>{children}</>;
};

export default InternalGate;
